<template>
    <main-layout class="bg-gray-100 min-h-screen flex flex-col">

        <!-- En-tête + CTA sur fond dégradé -->
        <div class="bg-gradient-to-b from-secondary to-primary">
            <div class="p-2 mb-5">
                <app-header icon="tools" class="text-white">
                    <div class="flex items-center justify-between">
                        <h1 class="text-2xl font-semibold tracking-wide">{{ fibsdd.numero }}</h1>
                    </div>
                </app-header>

                <action-bar :back="{ name: 'liste-fibsdd' }" class="!p-0 mb-2"></action-bar>
            </div>
        </div>

        <div id="container-fi"
            class="bg-gradient-to-b from-[#F8FBFF] to-[#E2E9F5] rounded-t-3xl -mt-6 flex-1 shadow-xl pb-28">
            <div class="shadow-2xl rounded-lg mb-30 bg-white p-4">
                <nav-fibsdd v-show="activeSection !== 'start'" :page="activeSection" @changeSection="navigateTo">
                </nav-fibsdd>

                <section id="start" v-show="activeSection === 'start'">

                    <small-recap :code="fibsdd.numero" :ot="fibsdd.ordre_travail" :detenteur="detenteur"
                        :installation="installation" :gotFluide="isFluide" :isFibsdd="isFibsdd">
                    </small-recap>

                    <nature-choice :natures="fibsdd.natures" @natureUpdated="updateNature"
                        @goToIntervention="navigateTo('intervention')" :gotFluide="isFluide" :isFibsdd="isFibsdd">
                    </nature-choice>

                </section>

                <section id="intervention" v-show="activeSection === 'intervention'">

                    <controle-etanch :nofuite="fibsdd.ctrlEtanch.no_fuites" :open="activeSubsection"
                        :detecteur="detecteur" @openCollapsible="openSubsection" @isValidChanged="updateValidCtrl"
                        v-if="isFluide && (fibsdd.natures.controleNonPeriodique || fibsdd.natures.controlePeriodique)">
                    </controle-etanch>

                    <manip-fluide :open="activeSubsection" :operations="fibsdd.operations" :idFi="fibsdd.id"
                        @newManip="updateManipFluide" @openCollapsible="openSubsection" v-if="isFluide">
                    </manip-fluide>

                    <infos :open="activeSubsection" :informations="fibsdd.informations" @infosChanged="updateInfos"
                        @openCollapsible="openSubsection">
                    </infos>

                    <gestion-pieces :open="activeSubsection" :pieces="fibsdd.pieces" @openCollapsible="openSubsection"
                        @infosChanged="updateInfos" @updatePieces="piecesChanged">

                    </gestion-pieces>

                    <a href="javascript: void 0" class="btn-primary mt-5 next" @click="navigateTo('finish')">
                        Finaliser
                        <i class="icon-go"></i>
                    </a>

                </section>

                <section id="finish" v-show="activeSection === 'finish'">

                    <div class="text-lg font-medium mb-4 uppercase text-secondary">
                        Récapitulatif de l’intervention
                    </div>

                    <small-recap :code="fibsdd.numero" :ot="fibsdd.ordre_travail" :detenteur="detenteur"
                        :installation="installation" :gotFluide="isFluide" :isFibsdd="isFibsdd">
                    </small-recap>

                    <recap :fibsdd="fibsdd" :fuites="this.fuites"></recap>

                    <client-infos :infosDet="fibsdd.infosDet" @infosDetUpdated="updateInfosDet"></client-infos>

                    <a class="btn-primary main-action cloturer" id="main-action" style="margin: 20px 0px;"
                        :class="classClotureWithSignature" @click.prevent="triggerSignature">
                        <strong>Signer et Clôturer </strong> l'intervention

                    </a>

                    <a class="btn-vert main-action cloturer w-full my-5" :class="classClotureWithoutSignature"
                        @click.prevent="triggerBypassSignature">

                        <i class="icon-error"></i>
                        <strong>Clôturer détenteur absent</strong> l'intervention
                    </a>


                    <signature-modal v-show="showModal" :signature="fibsdd.infosDet.signature_signataire64"
                        :clearOnClose="true" @signatureUpdated="updateSignature" @close="showModal = false">
                    </signature-modal>

                </section>


            </div>
        </div>

    </main-layout>

</template>

<script>

// SPECIFIC
import NavFibsdd from './subcomponents/Nav.vue'
import SmallRecap from './subcomponents/SmallRecap.vue'
import NatureChoice from './subcomponents/Nature.vue'
import ControleEtanch from './subcomponents/ControlEtanch.vue'
import ManipFluide from './subcomponents/ManipFluide.vue'
import Infos from './subcomponents/Infos.vue'
import Recap from './subcomponents/Recap.vue'
import ClientInfos from './subcomponents/ClientInfos.vue'
import GestionPieces from './subcomponents/GestionPieces.vue'
import SignatureModal from '../../common/SignatureModal.vue'

// OBJETS JS
import Fibsdd from '../../../js/models/Fibsdd'
import User from '../../../js/models/User'
import Detenteur from '../../../js/models/Detenteur'
import Outil from '../../../js/models/Outil'
import Installation from '../../../js/models/Installation'
import OperationBouteille from '../../../js/models/OperationBouteille'
import Fuite from '../../../js/models/Fuite'
import Piece from '../../../js/models/Piece'
import Offline from '../../../js/models/Offline'

export default {

    data() {
        return {

            fibsdd: {

                id: null,
                ordre_travail: null,
                numero: null,
                detenteur: null,
                installation: null,
                fluide_init: null,
                charge_init: null,

                natures: {
                    assemblage: false,
                    miseEnService: false,
                    modification: false,
                    maintenance: false,
                    controlePeriodique: false,
                    controleNonPeriodique: false,
                    demantelement: false,
                    retrofit: false,
                    newFluide: null,
                    autres: null,
                    observations: null
                },

                ctrlEtanch: {
                    fuites: [],
                    no_fuites: false
                },

                operations: [],

                informations: {
                    temps_deplacement: null,
                    temps_intervention: null,
                    pieces: null,
                    observations: null,
                    photo: null,
                    techs: null,
                    namesTechniciens: null,
                    finish: null,
                    garantie: null,
                    fromDevis: null,
                    needDevis: null,
                    preventif: null,
                    correctif: null,
                    travauxEffectues: null
                },

                pieces: [],

                photos: [],

                infosDet: {
                    nom_signataire: null,
                    qualite_signataire: null,
                    signature_signataire64: null
                },

                sendMail: null,
                cloture: null

            },

            installation: {},
            detenteur: {},
            fuites: [],
            detecteur: {},
            technicien: {},

            interventionIsValid: null,
            infosDetIsValid: true,

            activeSection: 'start',
            activeSubsection: null,

            showModal: false,

            isFluide: null,
            isFibsdd: null

        }
    },

    computed: {

        classClotureWithSignature() {
            if ((this.fibsdd.natures.controlePeriodique === false && this.fibsdd.natures.controleNonPeriodique === false) && this.infosDetIsValid === true) {
                return ''
            } else if (this.interventionIsValid === true && this.infosDetIsValid === true) {
                return ''
            } else if (!this.installation.fluide && this.infosDetIsValid === true) {
                return ''
            } else {
                return 'disabled'
            }
        },

        classClotureWithoutSignature() {
            if ((this.fibsdd.infosDet.nom_signataire === null || this.fibsdd.infosDet.nom_signataire === "") && (this.fibsdd.infosDet.fonction_signataire === null || this.fibsdd.infosDet.fonction_signataire === "")) {
                return ''
            } else {
                return 'disabled'
            }
        }

    },

    methods: {

        // NAVIGATION ACTIONS
        piecesChanged(pieces) {
            let piecesToSave = [];
            for (let p of pieces) {
                piecesToSave.push(p)
            }

            let fi = new Fibsdd;
            this.fibsdd.pieces = piecesToSave;
            let idFi = this.$route.params.id;

            fi.updateFibsdd(idFi, this.fibsdd, res => {

            })
        },

        navigateTo(section) {

            if (section === 'intervention') {

                if (_.isEmpty(this.detecteur) &&
                    (this.installation.fluide && (this.fibsdd.natures.controlePeriodique === true || this.fibsdd.natures.controleNonPeriodique === true))
                ) {
                    swal('Détecteur de fuites requis', "Vous devez ajouter et activer un détecteur de fuites manuel valide pour pouvoir faire un contrôle d'étanchéité.", 'warning');
                } else {
                    this.activeSection = section
                }

            } else if (section === 'finish') {

                this.fetchFuites();
                if (this.interventionIsValid ||
                    (this.fibsdd.natures.controlePeriodique === false && this.fibsdd.natures.controleNonPeriodique === false) ||
                    !this.installation.fluide
                ) {
                    this.activeSection = section;
                } else {
                    swal('Fiche incomplète', "Veuillez compléter le contrôle d'étanchéité", 'warning')
                }

            } else {
                this.activeSection = section

            }

        },

        openSubsection(type) {
            if (this.activeSubsection === type) {
                this.activeSubsection = null
            } else {
                this.activeSubsection = type
            }
        },

        updateValidCtrl(status) {
            this.fibsdd.ctrlEtanch.no_fuites = status.no_fuites;
            this.interventionIsValid = status.isValid
        },

        // FETCHING DATA
        // todo : clean ça !!
        fetchFibsddData() {

            return new Promise((resolve) => {

                let fi = new Fibsdd;
                let idFiche = this.$route.params.id;

                fi.getFibsdd(idFiche).then(dataFi => {

                    this.fibsdd.id = dataFi.id;
                    this.fibsdd.numero = dataFi.numero;
                    this.fibsdd.ordre_travail = dataFi.ordre_travail;
                    this.fibsdd.detenteur = dataFi.detenteur;
                    this.fibsdd.installation = dataFi.installation;
                    this.fibsdd.charge_init = dataFi.charge_init;
                    this.fibsdd.fluide_init = dataFi.fluide_init;
                    this.fibsdd.cloture = false;
                    this.fibsdd.cloturedAt = dataFi.cloturedAt;
                    this.fibsdd.photos = dataFi.photos;
                    this.fibsdd.natures = dataFi.natures;
                    this.fibsdd.ctrlEtanch.no_fuites = dataFi.ctrlEtanch.no_fuites;
                    this.fibsdd.informations = dataFi.informations;
                    this.fibsdd.infosDet = dataFi.infosDet;

                    // VALID STATUS
                    if (this.fibsdd.ctrlEtanch.no_fuites === true) {
                        this.interventionIsValid = true
                    }

                    if (!this.fibsdd.infosDet.nom_signataire) {
                        this.infosDetIsValid = false
                    }
                    if (!this.fibsdd.infosDet.fonction_signataire) {
                        this.infosDetIsValid = false
                    }

                    resolve(true)

                })

            })

        },

        fetchTechnicienData() {

            Outil
                .getDetecteurActif()
                .then(data => {
                    this.fibsdd.detecteur = data.id;
                    this.detecteur = data
                })
                .catch();

            User
                .getUserData(data => {
                    this.technicien = data
                })

        },

        fetchOperations() {

            let ops = new OperationBouteille;
            let idFiche = this.$route.params.id;

            ops
                .getOpsForFibsdd(idFiche)
                .then(data => {
                    this.fibsdd.operations = data
                })
                .catch()

        },

        fetchPieces() {

            let idFiche = this.$route.params.id;

            Piece
                .getListForFiche(idFiche)
                .then(res => this.fibsdd.pieces = res)
                .catch()

        },

        async fetchDetAndInstall() {

            this.detenteur = await Detenteur.getDetenteur(this.fibsdd.detenteur);
            this.installation = await Installation.getInstallation(this.fibsdd.installation);


            if (_.isEmpty(this.installation.fluide)) {

                this.isFluide = false;
                this.isFibsdd = false

            } else if (this.installation.fluide.id === 44) {
                //Si R999, popup changement de fluide !!!
                swal('Fluide non autorisé', "Veuillez remplacer le fluide R-999 de l'installation par un fluide existant.", 'error');

                swal({
                    title: 'Fluide non autorisé',
                    text: 'Veuillez remplacer le fluide R-999 de l\'installation par un fluide existant.',
                    type: 'error',
                    showCancelButton: false,
                    confirmButtonText: 'Ok',
                }).then(
                    () => this.$router.push({ name: "installation", params: { idInst: this.installation.id, id: this.detenteur.id } })
                )
            } else {

                this.fibsdd.charge_init = this.installation.charge;
                this.fibsdd.fluide_init = this.installation.fluide.id;

                this.isFluide = true;
                let typeFluide = this.installation.fluide.type;

                if (typeFluide === 'HFC' || typeFluide === 'HCFC' || typeFluide === 'CFC' || typeFluide === 'Mélange HFO/HFC') {
                    this.isFibsdd = true
                } else {
                    this.isFibsdd = false
                }


            }

        },

        fetchFuites() {
            return new Promise((resolve, reject) => {
                Fuite
                    .getListForFibsdd(this.$route.params.id)
                    .then(res => {
                        this.fuites = res;
                        resolve(res)
                    })
                    .catch(err => reject(err))
            })
        },

        // UPDATE DATA

        updateInfosDet(status) {
            this.infosDetIsValid = status;

            this.updateFi()

        },

        updateFi() {
            let fi = new Fibsdd;
            let idFi = this.$route.params.id;

            fi.updateFibsdd(idFi, this.fibsdd, res => {

            })

        },

        updateNature(natures) {

            let fi = new Fibsdd;
            this.fibsdd.natures = natures;
            let idFi = this.$route.params.id;

            fi.updateFibsdd(idFi, this.fibsdd, res => {

            })

        },

        updateManipFluide(operations) {
            this.fibsdd.operations = operations[0]
        },

        updateInfos(infos) {

            let fi = new Fibsdd;
            this.fibsdd.informations = infos;
            let idFi = this.$route.params.id;

            fi.updateFibsdd(idFi, this.fibsdd, res => {

            })
        },

        triggerSignature() {
            if (document.getElementById('main-action').classList.contains('disabled')) {
                swal('Fiche incomplète', 'Veuillez renseigner le nom et la fonction du signataire avant de clôturer la fiche.', 'warning')
            } else {
                this.showModal = true
            }
        },

        triggerBypassSignature() {
            if (document.getElementById("clotureWithoutSignature").classList.contains('disabled')) {
                swal('Info', 'Si vous souhaitez cloturer cette fiche sans signature, laisser les champs "Nom détenteur" et "Fonction" vides', 'warning')
            } else {
                this.closeFibsdd()
            }
        },

        async closeFibsdd() {
            let fi = new Fibsdd;
            let idFi = this.$route.params.id;

            // RETROFIT
            if (this.fibsdd.natures.retrofit === true) {
                await Installation.applyRetrofit(this.fibsdd.installation, this.fibsdd.id)
            }

            // DEMANTELEMENT
            if (this.fibsdd.natures.demantelement === true) {
                await Installation.applyDemantelement(this.fibsdd.installation)
            }

            this.fibsdd.cloture = true;
            this.fibsdd.cloturedAt = moment().format('YYYY-MM-DD HH:mm:ss');

            this.fibsdd.multiCtrl = false;

            let next = function (vue) {
                swal('Fiche clôturée', "La fiche d'intervention a bien été générée", 'success').then(() => {
                    if (navigator.onLine) {
                        swal({
                            title: 'Synchronisation',
                            text: "Vous êtes connecté à internet.\nVoulez-vous synchroniser maintenant ?",
                            type: 'question',
                            showCancelButton: true,
                            confirmButtonText: 'Oui',
                            cancelButtonText: 'Non',
                            allowOutsideClick: false,
                        }).then(
                            () => {
                                vue.$router.push({ name: 'synchro' })
                            },
                            () => {
                                vue.$router.push({ name: 'home' })
                            }
                        );
                    } else {
                        vue.$router.push({ name: 'home' })
                    }
                })
            };

            if (this.detenteur.email !== null && this.detenteur.email !== '' && this.detenteur.email !== undefined) {

                swal({
                    title: 'Envoi du rapport',
                    text: "Voulez vous envoyer la fiche d'intervention au détenteur ?",
                    type: 'question',
                    confirmButtonText: 'Oui',
                    showCancelButton: true,
                    cancelButtonText: 'Non',
                    allowOutsideClick: false
                }).then(
                    () => {
                        this.fibsdd.sendMail = true;

                        Offline.saveAction({
                            action: 'add',
                            type: 'clotureFibsdd',
                            sendMail: true,
                            detenteur: this.fibsdd.detenteur,
                            idFi: this.fibsdd.id
                        });

                        fi.updateFibsdd(idFi, this.fibsdd, () => {
                            next(this)
                        })

                    },
                    () => {
                        this.fibsdd.sendMail = false;

                        Offline.saveAction({
                            action: 'add',
                            type: 'clotureFibsdd',
                            sendMail: false,
                            detenteur: this.fibsdd.detenteur,
                            idFi: this.fibsdd.id
                        });

                        fi.updateFibsdd(idFi, this.fibsdd, () => {
                            next(this)
                        })
                    }
                )

            } else {

                this.fibsdd.sendMail = false;

                Offline.saveAction({
                    action: 'add',
                    type: 'clotureFibsdd',
                    sendMail: false,
                    detenteur: this.fibsdd.detenteur,
                    idFi: this.fibsdd.id
                });

                fi.updateFibsdd(idFi, this.fibsdd, () => {
                    next(this)
                })
            }
        },

        updateSignature(data) {

            this.fibsdd.infosDet.signature_signataire64 = data;

            this.closeFibsdd()

        }
    },

    mounted() {


        this
            .fetchFibsddData()
            .then(() => {
                this.fetchTechnicienData();
                this.fetchOperations();
                this.fetchDetAndInstall();
                this.fetchPieces()
            })


    },

    components: {
        SmallRecap,
        NatureChoice,
        ControleEtanch,
        ManipFluide,
        Infos,
        NavFibsdd,
        Recap,
        ClientInfos,
        GestionPieces,
        SignatureModal
    }

}

</script>



// WEBPACK FOOTER //
// Fibsdd.vue?2ebd4442